/**
 * Application version constant - Phase III: Multi-Tenant Architecture, RLS Security, Ghost Data Protection
 * This version is used to detect stale client versions
 * Update this value when deploying a new version
 */
export const APP_VERSION = '2.2.1';
